import { render, staticRenderFns } from "./ProductionTaskTypes.vue?vue&type=template&id=988d3636&scoped=true&"
import script from "./ProductionTaskTypes.vue?vue&type=script&lang=js&"
export * from "./ProductionTaskTypes.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTaskTypes.vue?vue&type=style&index=0&id=988d3636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988d3636",
  null
  
)

export default component.exports